import * as ko from 'knockout';
import code404 from './404';

export default function () {
  ko.components.register(code404.name, code404);
}
